import { render } from "./CallLog.vue?vue&type=template&id=4ac2aa5b&scoped=true"
import script from "./CallLog.vue?vue&type=script&lang=js"
export * from "./CallLog.vue?vue&type=script&lang=js"

import "./CallLog.vue?vue&type=style&index=0&id=4ac2aa5b&lang=less&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ac2aa5b"]])

export default __exports__